<template>
    <section>
      <v-parallax :src="asset" height="250">
        <v-layout column align-center justify-center class="white--text">
          <h1 v-if="title" class="white--text mb-2 display-1 text-xs-center image-title">{{title}}</h1>
          <div v-if="subtitle" class="subheading mb-3 text-xs-center">{{subtitle}}</div>
        </v-layout>
      </v-parallax>
    </section>
</template>

<script>
export default {
    props: ['asset', 'title', 'subtitle']
}
</script>

<style>

</style>
